import { render, staticRenderFns } from "./PPMList.vue?vue&type=template&id=3b3bba68&scoped=true&"
import script from "./PPMList.vue?vue&type=script&lang=ts&"
export * from "./PPMList.vue?vue&type=script&lang=ts&"
import style0 from "./PPMList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PPMList.vue?vue&type=style&index=1&id=3b3bba68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3bba68",
  null
  
)

component.options.__file = "PPMList.vue"
export default component.exports